/**
 * Build environment
 */

if (import.meta.env.PROD) {
  try {
    console.log(
      'Bundled at:',
      new Date(parseInt(import.meta.env.CREATED_AT)).toLocaleString('UK')
    );
  } catch (e) {
    console.error('Failed to parse bundle date. \n', e);
  }
}

const environment = {
  stage: import.meta.env.STAGE as 'DEV' | 'PROD',
  development: import.meta.env.DEV,
  production: import.meta.env.PROD,

  backend: import.meta.env.API_URL,

  google: {
    clientId: import.meta.env.GOOGLE_CLIENT_ID,
  },

  sentry: {
    dsn: import.meta.env.SENTRY_DSN,
    environment: import.meta.env.SENTRY_ENVIRONMENT,
    release: import.meta.env.SENTRY_RELEASE_COMMIT_SHA,
  },
};

if (environment.stage !== 'PROD') {
  console.log('Environment', { environment });
}

export { environment };
